import 'locales/i18n';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'react-calendar/dist/Calendar.css';
import 'styles/calendar.css';
import 'styles/tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <App />
);
